import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { MAP_VISUAL } from 'stores/mapControlsStore/types'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import { DefaultHeatmapRow } from '../DefaultHeatmapRow/DefaultHeatmapRow'

export const IrrigationFlowMeterHeatMapRow = () => {
  const pointValueType = mapControlsStore.useSelector(
    (s) => s.mapVisualValueGroup?.[MAP_VISUAL.POINT]?.irrigation_activity_flow_meters?.valueType,
  )

  // to get refreshes on unit changes working well
  const { volume, flowRate } = userDetailsStore.useSelector((s) => ({
    rain: s.rain,
    volume: s.volume,
    flowRate: s.flowRate,
  }))

  let suffix = ''

  if (pointValueType?.includes('currentFlowStatus')) return null

  if (pointValueType?.includes('cumulativeFlowMeter'))
    suffix = unitConverter.flowMeter(null, { outputUnit: volume }).suffix()

  if (pointValueType?.includes('currentFlowRate'))
    suffix = unitConverter.flowRate(null, { outputUnit: flowRate }).suffix()

  return <DefaultHeatmapRow suffix={suffix} />
}
